import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  createFilterOptions,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Category, Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { baseURL } from "../../../axios/axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const TemplateFileModal = ({ mode, handleCloseClick, editData }) => {
  const [loading, setLoading] = useState(false);
  const [notifType, setNotificationType] = useState([]);
  const [tempFile, setTemplateFile] = useState([]);
  const [initalHTML, setinitialHTML] = useState("");
  console.log(initalHTML);
  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    const notType = masterAPI["selectList"].notificationType;
    await axiosPrivate
      .get(`${notType}`)
      .then((res) => {
        setLoading(false);
        setNotificationType(res.data);
        console.log(res.data, "type");
      })
      .catch((e) => {
        setNotificationType([]);
        setLoading(false);
        console.log(e, "type");
      });
    const templatefilelink = masterAPI["notificationtemplate"].templatefiles;
    await axiosPrivate
      .get(`${templatefilelink}`)
      .then((res) => {
        setLoading(false);
        console.log("temp", res);
        setTemplateFile(res.data);
      })
      .catch((e) => {
        setTemplateFile([]);
        console.log(e, "errorfile");
      });
  };

  const initialValue = {
    code: mode === "Edit" ? editData.code : "",
    notificationType: mode === "Edit" ? editData.notificationType : "",
    fileName: mode === "Edit" ? editData.fileName : "",
    htmlContent: mode === "Edit" ? editData.htmlContent : "",
  };
  console.log("editData", editData);

  const onSubmit = async (value) => {
    const payload = {
      ...value,
      htmlContent: initalHTML,
    };
    console.log(payload);
    setLoading(true);
    const createLink = masterAPI["templatefile"].create;
    const updateLink = masterAPI["templatefile"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, payload)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "createAC");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...value,
      };
      console.log("updateAc", updateAC);
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "updateAC");
        });
    }
  };
  const handleHTML = (value) => {
    setinitialHTML(value);
  };
  const handleCancel = () => {
    handleCloseClick();
  };
  const extractEditableContent = (html) => {
    if (!html) return "";
    try {
      const doc = new DOMParser().parseFromString(html, "text/html");
      // Try to find common content containers in order of preference
      return (
        doc.querySelector(".container")?.innerHTML ||
        doc.querySelector(".content")?.innerHTML ||
        doc.querySelector("body")?.innerHTML ||
        html
      );
    } catch {
      return html; // Fallback if parsing fails
    }
  };

  const reconstructFullHtml = (editableContent, originalHtml) => {
    if (!originalHtml) return editableContent;

    try {
      const doc = new DOMParser().parseFromString(originalHtml, "text/html");
      const container =
        doc.querySelector(".container") ||
        doc.querySelector(".content") ||
        doc.querySelector("body");

      if (container) {
        container.innerHTML = editableContent;
        return doc.documentElement.outerHTML;
      }
      return originalHtml; // Fallback if we can't find a container
    } catch {
      return originalHtml; // Fallback if parsing fails
    }
  };
  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? "Update Template File" : "New Template File"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Type
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={notifType.length === 0}
                  options={notifType}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.text}
                  value={
                    notifType.find(
                      (p) => p.value === values.notificationType
                    ) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("notificationType", value.value);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="notificationtype"
                      placeholder="Select Notification Type"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                                                        <CircularProgress color="inherit" size={20} />
                                                                                      ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Template File
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={tempFile.length === 0}
                  options={tempFile}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.fileName}
                  value={
                    tempFile.find((p) => p.fileName === values.fileName) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    if (value !== null) {
                      if (mode === "Create" || mode === "Edit") {
                        handleHTML(value.htmlContent);
                      }
                      setFieldValue("fileName", value.fileName);
                    }
                  }}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>{option.fileName}</span>
                      <OpenInNewIcon
                        style={{ cursor: "pointer", marginLeft: 8 }}
                        fontSize="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          let htmlContent = option.htmlContent;
                          const blob = new Blob([htmlContent], {
                            type: "text/html",
                          });
                          const previewUrl = URL.createObjectURL(blob);

                          window.open(previewUrl, "_blank");
                        }}
                      />
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="htmlContent"
                      placeholder="Select file"
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: mode === "Edit" ? "block" : "none" }}
              >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  HTML Content Editor
                </Typography>

                <Box
                  sx={{
                    height: "400px",
                    mb: 2,
                    "& .ql-container": {
                      fontFamily: "Arial, sans-serif",
                      fontSize: "14px",
                      height: "350px",
                      overflowY: "auto",
                    },
                    // "& .ql-editor": {
                    //   minHeight: "350px",
                    // },
                  }}
                >
                  <ReactQuill
                    value={extractEditableContent(values.htmlContent)}
                    onChange={(content) => {
                      setFieldValue(
                        "htmlContent",
                        reconstructFullHtml(content, values.htmlContent)
                      );
                    }}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, false] }],
                        ["bold", "italic", "underline"],
                        ["blockquote", "code-block"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link"],
                        ["clean"],
                      ],
                      clipboard: {
                        matchVisual: false,
                      },
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "blockquote",
                      "code-block",
                      "list",
                      "bullet",
                      "link",
                    ]}
                    placeholder="Edit your content here..."
                  />
                </Box>

                <Button
                  variant="contained"
                  startIcon={<OpenInNewIcon />}
                  onClick={() => {
                    if (values.htmlContent) {
                      const blob = new Blob([values.htmlContent], {
                        type: "text/html",
                      });
                      window.open(URL.createObjectURL(blob), "_blank");
                    }
                  }}
                  disabled={!values.htmlContent}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Preview Content
                </Button>
              </Grid>
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default TemplateFileModal;
